import React from 'react';
import classNames from 'classnames';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputSelect from '../../../FormFields/Select';
import Checkbox from '../../../FormFields/Checkbox';
import withSectionActions from '../withSectionActions';
import { fontSizeOptions } from '../../../../Models/Section';
import { SCORE_OPTIONS_AVERAGE, COLUMNS_OPTIONS } from '../../../../Context/DynamicFormContext';
import ConfigService from '../../../../Services/api/Config';

import './style.scss';

export class SectionWidget extends React.PureComponent {

  checkLabelValidation = (value) => {
    const { api, section } = this.props;
    const sections = api.getAllSections();
    for (const element of sections) {
      if (element.label && element.label.toLowerCase() === value.toLowerCase() && element.id !== section.id) {
        return 'This field can not be repeated.';
      }
    }
    return '';
  };

  renderConfigTab = (internalSection, changeSectionValue, changeSectionError) => {
    const {api} = this.props;
    return (
      <div className="Widget_Form_Config">
        <InputText
          label="Label"
          required
          value={api.getFieldsVerbiage(internalSection, 'label')}
          onChange={(v) => changeSectionValue('label', v)}
          error={internalSection.errors['label']}
          onError={(error) => changeSectionError('label', error)}
          validators={[this.checkLabelValidation]}
        />
        <InputSelect
          label="Number of columns (Desktop)"
          value={internalSection.columns}
          onChange={(v) => changeSectionValue('columns', v)}
          options={COLUMNS_OPTIONS}
        />
        <InputSelect
          label="Font size"
          value={internalSection.fontSize}
          onChange={(v) => changeSectionValue('fontSize', v)}
          options={fontSizeOptions()}
        />
        <InputSelect
          label="Score type"
          value={internalSection.scoreType}
          onChange={(v) => changeSectionValue('scoreType', v)}
          options={SCORE_OPTIONS_AVERAGE}
        />
        <div className="InputCheckboxesWrapper">
          <Checkbox
            onChange={(v) => changeSectionValue('hide', v)}
            label="Hide header"
            checked={internalSection.hide}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('cloneEnabled', v)}
            label="Cloning enabled"
            checked={internalSection.cloneEnabled}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('bold', v)}
            label="Bold"
            checked={internalSection.bold}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('italic', v)}
            label="Cursive"
            checked={internalSection.italic}
            className="InputCheckbox_Block"
          />
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox
            onChange={(v) => changeSectionValue('lockDDR', v)}
            label="Lock in DDR"
            checked={internalSection.lockDDR}
            className="InputCheckbox_Block"
          />
          <Checkbox
            onChange={(v) => changeSectionValue('lockLabel', v)}
            label="Lock Label"
            checked={internalSection.lockLabel}
            className="InputCheckbox_Block"
          />
        </div>
      </div>
    );
  };

  render() {
    const { section, renderForm } = this.props;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'Section Divider',
      className: 'WrapperWidget_Inline',
      field: { scoreType: section ? section.scoreType : null }
    };

    return (
      <WrapperWidget {...props}>
        <div className="SectionWidget">
          <div
            style={{
              fontSize: section && section.fontSize ? section.fontSize.label : null,
              color: ConfigService.getColor('tertiaryColor')
            }}
            className={classNames('Widget_Label', {
              Bold: Boolean(section ? section.bold : false),
              Italic: Boolean(section ? section.italic : false)
            })}>
            {section ? section.label : ''}
          </div>
          <hr />
        </div>
      </WrapperWidget>
    );
  }
}

export const SectionWidgetEditable = withSectionActions(SectionWidget);
